import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';



import { FilterModule } from '../../filter/filter.module';

import { TagModule } from '../../tag';
import { BodisplayModule } from '../../bodisplay';
import { CustomgridModule } from '../../customgrid';
import { AutoSearchModule } from '../../autosearch';
import { PipeModule } from '../../pipes';
import { AvatarSearchModule } from '../../avatar-search';
import { DateModule } from '../../date';
import { ProduitActionModule } from '../../produit-action/produit-action.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TagModule,
    BodisplayModule,
    CustomgridModule,
    ScrollingModule,
    RouterModule,
    AutoSearchModule,
    PipeModule,
    TagModule,
    NgbModule,
    AvatarSearchModule,
    DateModule,
    FilterModule,
    ProduitActionModule,
  ],
  declarations: [  
  ],
  exports: [
    CommonModule,
    FormsModule,
    TagModule,
    /*VirtualScrollerModule,*/
    BodisplayModule,
    CustomgridModule,
    ScrollingModule,
    RouterModule,
    AutoSearchModule,
    PipeModule,
    TagModule,
    NgbModule,
    AvatarSearchModule,
    DateModule,
    FilterModule,
    ProduitActionModule,
  ]
})

export class BasePipelineModule { }
